import { render, staticRenderFns } from "./massiveFacialLoad.vue?vue&type=template&id=2245c7b7&scoped=true"
import script from "./massiveFacialLoad.vue?vue&type=script&lang=js"
export * from "./massiveFacialLoad.vue?vue&type=script&lang=js"
import style0 from "./massiveFacialLoad.vue?vue&type=style&index=0&id=2245c7b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245c7b7",
  null
  
)

export default component.exports